module.exports = __webpack_public_path__ + "8221c834e245686c5d8e2235afc3199f.png";